import { useEffect, useMemo, useState } from 'react';
import api from '../../services/api';

const FAMILY_FILTERS = {
  all: () => true,
  edge: () => true,
  time: () => true,
  confidence: () => true,
  ust_kg: (item) => item.family === 'UST_KG',
  ms: (item) => item.family === 'MS',
  live_watch: (item) => item.section === 'nearValueBets'
};

const sortItems = (items = [], filter = 'edge') => {
  const cloned = [...items];

  if (filter === 'time') {
    return cloned.sort((a, b) => new Date(a.matchDate) - new Date(b.matchDate));
  }

  if (filter === 'confidence') {
    return cloned.sort((a, b) => (b.confidence || 0) - (a.confidence || 0));
  }

  return cloned.sort((a, b) => (b.edge || 0) - (a.edge || 0));
};

export const usePremiumOpportunities = (filter = 'edge') => {
  const [data, setData] = useState({
    realValueBets: [],
    nearValueBets: [],
    pricedByMarket: [],
    summary: { realCount: 0, nearCount: 0, pricedCount: 0 },
    message: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await api.getValueBetSummary();
        setData({
          realValueBets: Array.isArray(response?.realValueBets) ? response.realValueBets : [],
          nearValueBets: Array.isArray(response?.nearValueBets) ? response.nearValueBets : [],
          pricedByMarket: Array.isArray(response?.pricedByMarket) ? response.pricedByMarket : [],
          summary: response?.summary || { realCount: 0, nearCount: 0, pricedCount: 0 },
          message: response?.message || ''
        });
        setRefreshing(response?.status === 'preparing');
      } catch (err) {
        setError(err.message || 'Value bet verisi alinamadi');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filterFn = FAMILY_FILTERS[filter] || FAMILY_FILTERS.all;

  const realValueBets = useMemo(
    () => sortItems(data.realValueBets.filter(filterFn), filter),
    [data.realValueBets, filter, filterFn]
  );
  const nearValueBets = useMemo(
    () => sortItems(data.nearValueBets.filter(filterFn), filter),
    [data.nearValueBets, filter, filterFn]
  );
  const pricedByMarket = useMemo(
    () => sortItems(data.pricedByMarket.filter(filterFn), filter === 'time' ? 'confidence' : filter),
    [data.pricedByMarket, filter, filterFn]
  );

  return {
    loading,
    error,
    refreshing,
    realValueBets,
    nearValueBets,
    pricedByMarket,
    summary: data.summary,
    message: data.message
  };
};
